module.exports = __webpack_public_path__ + "img/features.8234accf.png";